import { render, staticRenderFns } from "./MySchedule.vue?vue&type=template&id=70889396&scoped=true&"
import script from "./MySchedule.vue?vue&type=script&lang=js&"
export * from "./MySchedule.vue?vue&type=script&lang=js&"
import style0 from "./MySchedule.vue?vue&type=style&index=0&id=70889396&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70889396",
  null
  
)

export default component.exports